// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"topic-page-loader_loader-container___2Ieb"};